export const blockIconsContentMail = (
	<span className='material-symbols-outlined'>mail</span>
);
